/**
 * Makes the entire old header stick when scrolling up past a certain point,
 * and restores it when returning to the top.
 *
 * Behavior:
 * - When scrolling up and past 140px → header becomes fixed.
 * - When returning above 40px → header returns to normal.
 */
const initScrollHeaderUp = () => {
  const oldHeader = document.querySelector('.old-header');
  if (oldHeader) {
    let last = window.scrollY;
    let isFixed = false;
    const fix_on = 140;
    const unfix_below = 40;

    const fix = () => {
      if (isFixed) return;
      oldHeader.classList.add('is-fixed');
      oldHeader.style.top = '0';
      isFixed = true;
    };

    const unfix = () => {
      if (!isFixed) return;
      oldHeader.classList.remove('is-fixed');
      oldHeader.style.top = '';
      isFixed = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        const y = window.scrollY;
        const scrollingUp = y < last;
        last = y;

        if (!isFixed && scrollingUp && y > fix_on) fix();
        else if (isFixed && y < unfix_below) unfix();
      },
      { passive: true }
    );
  }

  /* NEW HEADER LOGIC (.header-group--new-header)*/
  const newHeader = document.querySelector('.header-group--new-header');

  if (newHeader) {
    let spacer = document.querySelector('.header-spacer');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'header-spacer';
      newHeader.after(spacer);
    }

    const setSpacerHeight = () => {
      const h = newHeader.getBoundingClientRect().height;
      spacer.style.height = h + 'px';
    };

    setSpacerHeight();
    window.addEventListener('load', setSpacerHeight);
    window.addEventListener('resize', setSpacerHeight);

    let lastY = window.scrollY;
    const topShow = 8;
    const hideThreshold = 120;

    if (window.scrollY <= topShow) {
      newHeader.classList.remove('is-hidden');
    }

    window.addEventListener(
      'scroll',
      () => {
        const y = window.scrollY;
        const goingDown = y > lastY;
        const goingUp = y < lastY;

        if (y <= topShow) {
          newHeader.classList.remove('is-hidden');
        } else if (goingUp && y > hideThreshold) {
          newHeader.classList.add('is-hidden');
        } else if (goingDown) {
          newHeader.classList.remove('is-hidden');
        }

        lastY = y;
      },
      { passive: true }
    );
  }

  /* MINI CART STYLES BY BREAKPOINT */
  const mq = window.matchMedia('(min-width: 1200px)');
  const miniCartSelector = '.mini-cart-content';

  function setMiniCartStyles(activeHeader) {
    document.querySelectorAll(miniCartSelector).forEach((el) => {
      if (activeHeader === 'old') {
        el.style.setProperty('margin-top', '0', 'important');
        el.style.setProperty('height', '100dvh', 'important');
      } else {
        el.style.removeProperty('margin-top');
        el.style.removeProperty('height');
      }
    });
  }

  function applyByBreakpoint() {
    const activeHeader = mq.matches ? 'new' : 'old';
    setMiniCartStyles(activeHeader);
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', applyByBreakpoint);
  } else if (mq.addListener) {
    mq.addListener(applyByBreakpoint);
  }

  applyByBreakpoint();
};

export default initScrollHeaderUp;